import { Routes } from '@angular/router';
import { Shell } from './layout/shell/shell';
import { authGuard } from './core/auth/auth.guard';
import { credentialAdminGuard } from './core/auth/credential-admin.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login').then((m) => m.Login),
  },
  {
    path: '',
    component: Shell,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () => import('./features/dashboard/dashboard').then((m) => m.Dashboard),
      },
      {
        path: 'products',
        loadComponent: () =>
          import('./features/products/product-list').then((m) => m.ProductList),
      },
      {
        path: 'products/new',
        loadComponent: () =>
          import('./features/products/product-form').then((m) => m.ProductForm),
      },
      {
        // NOTE: must precede 'products/:id' so 'import' isn't matched as an id.
        path: 'products/import',
        loadComponent: () =>
          import('./features/products/product-import').then((m) => m.ProductImport),
      },
      {
        path: 'products/:id',
        loadComponent: () =>
          import('./features/products/product-form').then((m) => m.ProductForm),
      },
      {
        path: 'categories',
        loadComponent: () =>
          import('./features/categories/category-list').then((m) => m.CategoryList),
      },
      {
        path: 'categories/new',
        loadComponent: () =>
          import('./features/categories/category-form').then((m) => m.CategoryForm),
      },
      {
        path: 'categories/:id',
        loadComponent: () =>
          import('./features/categories/category-form').then((m) => m.CategoryForm),
      },
      {
        path: 'banners',
        loadComponent: () =>
          import('./features/banners/banner-list').then((m) => m.BannerList),
      },
      {
        path: 'banners/new',
        loadComponent: () =>
          import('./features/banners/banner-form').then((m) => m.BannerForm),
      },
      {
        path: 'banners/:id',
        loadComponent: () =>
          import('./features/banners/banner-form').then((m) => m.BannerForm),
      },
      {
        path: 'orders',
        loadComponent: () => import('./features/orders/order-list').then((m) => m.OrderList),
      },
      {
        path: 'orders/:id',
        loadComponent: () => import('./features/orders/order-detail').then((m) => m.OrderDetail),
      },
      {
        path: 'collections',
        loadComponent: () => import('./features/collections/collection-list').then((m) => m.CollectionList),
      },
      {
        path: 'collections/new',
        loadComponent: () => import('./features/collections/collection-form').then((m) => m.CollectionForm),
      },
      {
        path: 'collections/:id',
        loadComponent: () => import('./features/collections/collection-form').then((m) => m.CollectionForm),
      },
      {
        path: 'coupons',
        loadComponent: () => import('./features/coupons/coupon-list').then((m) => m.CouponList),
      },
      {
        path: 'coupons/new',
        loadComponent: () => import('./features/coupons/coupon-form').then((m) => m.CouponForm),
      },
      {
        path: 'coupons/:id',
        loadComponent: () => import('./features/coupons/coupon-form').then((m) => m.CouponForm),
      },
      {
        path: 'reviews',
        loadComponent: () => import('./features/reviews/review-list').then((m) => m.ReviewList),
      },
      {
        path: 'users',
        loadComponent: () => import('./features/users/user-list').then((m) => m.UserList),
      },
      {
        path: 'users/:id',
        loadComponent: () => import('./features/users/user-detail').then((m) => m.UserDetail),
      },
      {
        path: 'transactions',
        loadComponent: () => import('./features/transactions/transaction-list').then((m) => m.TransactionList),
      },
      {
        path: 'gift-vouchers',
        loadComponent: () => import('./features/gift-vouchers/gift-voucher-list').then((m) => m.GiftVoucherList),
      },
      {
        path: 'gift-vouchers/new',
        loadComponent: () => import('./features/gift-vouchers/gift-voucher-form').then((m) => m.GiftVoucherForm),
      },
      {
        path: 'gift-vouchers/:id',
        loadComponent: () => import('./features/gift-vouchers/gift-voucher-form').then((m) => m.GiftVoucherForm),
      },
      {
        path: 'addresses',
        loadComponent: () => import('./features/addresses/address-list').then((m) => m.AddressList),
      },
      {
        path: 'carts',
        loadComponent: () => import('./features/carts/cart-list').then((m) => m.CartList),
      },
      {
        path: 'wishlists',
        loadComponent: () => import('./features/wishlists/wishlist-list').then((m) => m.WishlistList),
      },
      {
        path: 'settings/providers',
        canActivate: [credentialAdminGuard],
        loadComponent: () => import('./features/settings/provider-list').then((m) => m.ProviderList),
      },
      {
        // NOTE: must precede 'settings/providers/:id' so 'new' isn't matched as an id.
        path: 'settings/providers/new',
        canActivate: [credentialAdminGuard],
        loadComponent: () => import('./features/settings/provider-form').then((m) => m.ProviderForm),
      },
      {
        path: 'settings/providers/:id',
        canActivate: [credentialAdminGuard],
        loadComponent: () => import('./features/settings/provider-form').then((m) => m.ProviderForm),
      },
      {
        path: '**',
        loadComponent: () => import('./features/not-found/not-found').then((m) => m.NotFound),
      },
    ],
  },
];
